import { GetListRequest, GetDetailRequest } from '@rest/ViewSetHttpService';

/**
 * Query keys for content settings
 * Structured keys for precise cache invalidation
 */
export const contentSettingsKeys = {
  all: ['contentSettings'] as const,
  lists: () => [...contentSettingsKeys.all, 'list'] as const,
  list: (params?: GetListRequest) => [...contentSettingsKeys.lists(), params] as const,
  details: () => [...contentSettingsKeys.all, 'detail'] as const,
  detail: (uuid: string, params?: GetDetailRequest) =>
    [...contentSettingsKeys.details(), uuid, params] as const,
  detailById: (uuid: string) => [...contentSettingsKeys.details(), uuid] as const,
  invalidateAll: (): readonly string[] => contentSettingsKeys.all,
  invalidateLists: (): readonly string[] => contentSettingsKeys.lists(),
};
